// eslint-disable-next-line @github-ui/github-monorepo/filename-convention, import/no-namespace
import * as Octicons from '@primer/octicons-react'

export const COPY = {
  logo: {
    label: 'Copilot',
    href: '/',
  },
  links: {
    docs: {
      label: 'Documentation',
      href: 'https://docs.github.com/copilot',
      isExternal: true,
    },
    changelog: {
      label: 'Changelog',
      href: 'https://github.blog/changelog/label/copilot',
      isExternal: true,
    },
    copilotBusiness: {
      label: 'Copilot for Business',
      href: 'https://github.com/features/copilot/copilot-business',
      isExternal: true,
    },
  },
  a11y: {
    logo: 'Github homepage',
    close: 'Close sidebar',
  },
} as const

export const LINK_ICONS: Record<keyof typeof COPY.links, Octicons.Icon> = {
  docs: Octicons.BookIcon,
  changelog: Octicons.FileDiffIcon,
  copilotBusiness: Octicons.OrganizationIcon,
}
